import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import "./setUpProject.css";
import DatePicker from "react-date-picker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import * as actionTypes from "../../redux/actionTypes";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Button } from "@mui/material";
import { useParams } from "react-router";
import { motion } from "framer-motion";


import {
  GetAllCompanyData,
  GetProject,
  findCompanyData,
  getCheckData,
  getWorkspace,
  getTemplatesApiHandler
} from "../../WorkSpace/Components/ApiServices/apiHandler";
import { getProjectOptions } from "../../services/api/StandAlone/project";
import { createPreset } from "../../services/api/StandAlone/preset";
import { getOneBookClosure, linkToFinacial } from "../../Bookclosure/Services/ApiHandler";
import { customStyles } from "../../Bookclosure/Components/AddTaskModal";

import commoncss from "../../myfin_v2/css/common.module.css"
import saCreationcss from "../../myfin_v2/css/standaloneCreation.module.css"
import { ReactComponent as RightIcon } from "../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as LeftIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as CalenderIcon } from "../../myfin_v2/assets/icons/calender.svg"
import StandaloneProgressBar from "../../WorkSpace/Workspace2/StandaloneProgressBar"
import InputGroup from '../../myfin_v2/elements/InputGroup';
import CustomDropdownIndicator from "../../myfin_v2/elements/CustomDropdownIndicator";
import { Button as CustomButton } from "../../myfin_v2/elements/Button";
import buttoncss from "../../myfin_v2/css/button.module.css";

const initialState = {
  company: "",
  projectName: "",
  companyNature: "",
  GAAP: "",
  prevDate: moment().subtract(1, "years").toDate(),
  currentDate: moment().toDate(),
  preset: "",
  currency: "",
};

const gaapOptions = [
  { value: "IND AS", label: "IND AS" },
  { value: "UK Gaap", label: "UK GAAP", isDisabled: true },
  { value: "US Gaap", label: "US GAAP", isDisabled: true },
  { value: "GAAP", label: "GAAP" },
  { value: "IFRS", label: "IFRS" },
];

const natureOptions = [
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Trading", label: "Trading", isDisabled: true },
  { value: "NBFC", label: "NBFC", isDisabled: false },
  { value: "Banking", label: "Banking", isDisabled: true },
];

const QuestionnaireNew = () => {
  const animatedComponents = makeAnimated();
  const customSelectStyles = {
    ...customStyles,
    control: (provided, state) => ({
      ...customStyles.control(provided, state),
      minHeight: "35px",
      height: "35px",
      borderRadius: "6px",
    }),
    dropdownIndicator: (provided, state) => ({
      ...customStyles.dropdownIndicator(provided, state),
      marginTop: "-8px",
    }),
    option: (provided, state) => ({
      ...customStyles.option(provided, state),
      backgroundColor: state.isSelected
        ? "#f4faf5"
        : state.isFocused
        ? "#f4faf5"
        : "transparent",
      margin: "4px",
      width: "calc(100% - 16px)", // Ensure width accounts for margin so it doesn't overflow
      ":active": {
        backgroundColor: "#f4faf5",
      },
    }),
    singleValue: (provided, state) => ({
      ...customStyles.singleValue(provided, state),
      marginTop: "-5px",
    }),
    multiValue: (provided, state) => ({
      ...customStyles.multiValue(provided, state),
      margin: "0px 4px 0px 0px", // 0 top margin to prevent clipping, 4px right margin for spacing
      height: "22px",
      display: "flex",
      alignItems: "center",
    }),
    valueContainer: (provided, state) => ({
      ...customStyles.valueContainer(provided, state),
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
    }),
    multiValueLabel: (provided, state) => ({
      ...customStyles.multiValueLabel(provided, state),
      fontSize: "12px",
      padding: "0px 6px",
    }),
    multiValueRemove: (provided, state) => ({
      ...customStyles.multiValueRemove(provided, state),
      padding: "0 4px",
      height: "100%",
    }),
    placeholder: (provided, state) => ({
      ...customStyles.placeholder(provided, state),
      marginTop: "-5px",
    }),
  };
  const templateSelectStyles = {
    ...customSelectStyles,
    menuList: (provided) => ({
      ...provided,
      maxHeight: "150px",
    }),
  };
  const dispatch = useDispatch();
  let history = useHistory();
  const param = useParams();
  const [value, setValue] = useState(initialState);
  const [companyval, setCompany] = useState("");
  const [valid, setValid] = useState(false);
  const [extra, setExtra] = useState("");
  const [workspaceData, setWorkspace] = useState("");
  const [previousdata, setPreviousData] = useState("");
  const [oneCompany, setOneCompanyData] = useState("");
  const [allCompany, setAllCompany] = useState([]);
  const [allTemplates, setAllTemplates] = useState([]);
  const [selTemplate, setSelTemplate] = useState("");

  const [allProject, setAllProject] = useState([]);
  const [companyAll, setCompanyAll] = useState([]);
  const [presetAll, setPresetAll] = useState([]);
  const [w_id, setW_id] = useState("");
  const [importFs, setImportFs] = useState(false);
  const [bookClosureId, setBookclosureId] = useState("");
  const [comparativePeriod, setComparativePeriod] = useState(null);
  const [interimReporting, setInterimReporting] = useState(false);
  const [openCal, setOpenCal] = useState(false);
  const pickerRef = useRef(null);
  useEffect(() => {
    setW_id(param.wid);
    getWorkSpaceCheck(param.wid);
    companyData();
    projectData();
    GetBookclosureId();
  }, []);

  const companyData = async () => {
    try {
      const res = await GetAllCompanyData();
      if (res.status === 200) {
        setAllCompany(res.data.getAllCompanyData);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const projectData = async () => {
    try {
      const res = await GetProject();
      if (res.status === 200) {
        setAllProject(res.data.project);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const GetBookclosureId = async () => {
    try {
      const res = await getOneBookClosure(param.wid);
      if (res.status === 200) {
        setBookclosureId(res.data.bookClosure._id);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const getPreviousYearData = (w_id, companyNatureValue) => {
    getProjectOptions(w_id, companyNatureValue)
      .then(res => setPresetAll(res.data.projectsData))
      .catch(err => swal("Error", err.response?.data?.error || "Project Data Not Found !", "error"));
  };

  const handleChange = async (field, e) => {
    if (field === "company") {
      const findCompany = await findCompanyData(e.value);
      console.log("response", findCompany.data.getOneCompany[0]);
      if (findCompany.status === 200) {
        setOneCompanyData(findCompany.data.getOneCompany[0]);
        const companyNature = findCompany.data.getOneCompany[0]?.nature_of_company;

        setValue({ ...value, companyNature });

        getPreviousYearData(w_id, companyNature);
      }
      setCompany(e.value);
    }
    // else if (field === "companyNature"){
    //   setValue({ ...value, [field]: e.value });
    //   getPreviousYearData(w_id, e.value);
    // }
    else {
      setValue({ ...value, [field]: e.value });
    }
  };


  const handleCheckbox = (e) => {
    if (e.target.checked === true && bookClosureId === "") {
      swal("Warning", "Bookclosure Id not found in this Workspace", "warning");
    }
    setImportFs(e.target.checked);
  }

  function validationExisting() {
    let val = delete value.company;
    let obj = Object.values(val);
    if (obj.includes("") | obj.includes(null) && obj[5] !== "") {
      setValid(false);
    } else {
      setValid(true);
    }
  }

  useEffect(() => {
    validationExisting();
    getWorkspaceData(param.wid);
  }, [value]);

  const handleSubmit = () => {
    if (importFs === true && bookClosureId === "") {
      swal("Warning", "Bookclosure Id not found in this Workspace", "warning");
      return false;
    }
    if (valid) {
      const fd = {
        company: companyval,
        project_name: value.projectName,
        company_type: value.companyNature,
        gaap_selection: value.GAAP,
        current_year: moment(workspaceData[0]?.standalone_cy).format(),
        previous_year: moment(workspaceData[0]?.standalone_py).format(),
        previous_year_data: previousdata,
        extra_data: extra,
        type_fs: "vvv",
        preset_name: "not available",
        currency: oneCompany.functional,
        workspace_id: w_id,
        groupingTemplateID: selTemplate,
        interimReporting: interimReporting,
        comparativePeriod: comparativePeriod ? moment(comparativePeriod).toISOString() : null
      };

      // console.log(fd, "fd created");
      // dispatch(existingProject(fd))
      // fd.append('email','Value.email');
      // fd.append('password','Value.password');
      // console.log(Value)

      if (previousdata && previousdata.length > 0) {
        const filterPrevData = (previousdata || []).filter(ele => ele.label !== "Select");
        if (filterPrevData.length === 0) return swal("Warning", "Please Select Preset.", "warning");

        fd.previous_year_data = filterPrevData;

        dispatch({ type: "CREATE_PROJECT", payload: fd });
        dispatch({ type: "SELECTED_PRESETS", payload: filterPrevData });
        createPreset({ creating_project: fd })
          .then((res) => {
            history.push(`/preset/${res.data.presetId}`);
          })
          .catch((err) => {
            console.log("error happening while creating preset", err);
          });
      } else {
        const auth = localStorage.getItem("auth_token");
        let headers = {
          "x-auth-token": auth,
          "Content-Type": "application/json",
        };
        axios
          .post(`api/v1/tb-onboarding/tb-onboarding`, fd, { headers })
          .then((response) => {
            // if checkbox checked then 
            if (importFs === true) {
              const data = {
                bookClosureID: bookClosureId,
                companyID: companyval,
                projectID: response.data.project_id
              }
              linkToFinacial(data)
                .then((res) => {
                  history.push(`/financialstatement/${param.wid}`);
                })
                .catch((err) => {
                  console.log("error happening while import tb", err);
                  swal("Warning", "TB not uploaded in this company", "warning");
                });
            } else {
              history.push("/createProject/uploadTb");
            }
            dispatch({ type: actionTypes.SET_RESTART, payload: "arr" });
            dispatch({ type: actionTypes.SET_NOTERESTART, payload: "arr" });
            localStorage.setItem("project_id", response.data.project_id);
          })
          .catch((error) => {
            swal("", error.response.data.error, "error");
          });
      }
    } else {
      swal("", "Please Fill All the input Fields", "warning");
    }
  };


  const getFinancialDate = (e, type) => {
    if (type === "current") {
      setValue({ ...value, currentDate: e });
    } else {
      setValue({ ...value, prevDate: e });
    }
    getPreviousYearData();
  };

  const getWorkspaceData = async (w_id) => {
    const res = await getWorkspace(w_id);
    if (res.status === 200) {
      setWorkspace(res.data.getworkspace);
    }
  };


  const getWorkSpaceCheck = async (w_id) => {
    const res = await getCheckData(w_id);
    if (res.status === 200) {
      setCompanyAll(res.data.getIR[0]?.all_company_checked);
    }
  };

  const CompanyName = (c_id) => {
    try {
      const nameCompany = allCompany.filter((adj) => adj._id === c_id);
      const result = nameCompany[0]?.company_name
        ? nameCompany[0]?.company_name
        : "unknown";
      return result;
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };

  useEffect(() => {
    getTemplates();
  }, []);
  const getTemplates = () => {
    getTemplatesApiHandler({ sortField: "createdAt", sortOrder: "desc" })
      .then((response) => {

        if (response?.data?.success === true) {
          var templatesResp = response?.data?.groupingTemplateArray;
          templatesResp.forEach((obj) => {
            // if (obj.templateType === "default") {
            setAllTemplates((prev) => [...prev, { value: obj._id, label: obj.name }]);
            // }
            // if (obj.templateType === "custom") {
            //   setCustomLibraryList((prev) => [...prev, obj]);
            // }
          });
        }
      })
      .catch((error) => {
        // setCompanyData({});
      });
  };

  return (
    <>
      <div className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
        <div >
          <StandaloneProgressBar
            ActiveStage={1} />
        </div>
        <div style={{ marginTop: "5px" }}>
          <motion.div
            initial={{ x: 500, y: 500, opacity: 0 }}
            animate={{ x: 0, y: 0, opacity: 1 }}
            exit={{ x: 0, y: 0, opacity: 0 }}
            transition={{ duration: 0.7, ease: "easeInOut" }} className={saCreationcss.wsCrtNameDiv} style={{  padding: "32px 28px",  minHeight: "auto", height: "auto"}}>
            <span className={`${saCreationcss.wsCreationCatHeading} ${commoncss.fs32}`}>
              Create Blank Project
            </span>
            <span className="w-50">
              <div className={`${commoncss.inputCol}`} style={{ "margin-top": "26px", "padding": "0 0 20px" }}>
                {/* <input
                  style={{ width: "450px" }}
                  placeholder="Workspace Name here"
                  // className="wp-setup-form-input"
                  type="text"
                  onChange={handleChange}
                /> */}

                <InputGroup
                  class2_={commoncss.gap20}
                  inputs={[
                    <>
                      {w_id === "noWp" ? (
                        ""
                      ) : (
                        <>
                          <span className="input-label">Company</span>
                          <Select
                            placeholder="Select Company"
                            options={companyAll?.map((det) => {
                              return { value: det, label: CompanyName(det) };
                            })}
                            onChange={(e) => handleChange("company", e)}
                            className={`w-100 mt-0`}
                            classNamePrefix="select"
                            components={{
                              ...animatedComponents,
                              IndicatorSeparator: () => null,
                              DropdownIndicator: CustomDropdownIndicator,
                            }}
                            styles={customSelectStyles}
                          />
                        </>)}
                    </>,
                    <>
                      <InputGroup
                        label="Nature of Company"
                        inputs={[
                          <>
                            <input
                              type="text"
                              placeholder="Enter nature of Company"
                              value={oneCompany?.nature_of_company}
                              style={{ height: "35px", boxSizing: "border-box", borderRadius: "6px" }}
                              disabled
                            />
                          </>,
                        ]}
                      />
                    </>,
                  ]}
                />
                <InputGroup
                  class2_={commoncss.gap20}

                  inputs={[
                    <>
                      <InputGroup
                        label="Name of the Financials"
                        inputs={[
                          <>
                            <input
                              type="text"
                              placeholder="Enter name of the financials"
                              style={{ height: "35px", boxSizing: "border-box", borderRadius: "6px" }}
                              onChange={(e) => {
                                setValue({ ...value, ["projectName"]: e.target.value });
                              }}
                            />
                          </>
                        ]}
                      />
                    </>,
                    <>
                      <span className="input-label">Select the GAAP</span>
                      <Select
                        placeholder="Select the GAAP"
                        options={gaapOptions}
                        onChange={(e) => handleChange("GAAP", e)}
                        className={`w-100 mt-0`}
                        classNamePrefix="select"
                        components={{
                          ...animatedComponents,
                          IndicatorSeparator: () => null,
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        styles={customSelectStyles}
                      />
                    </>,
                  ]}
                />

                {/* <InputGroup
                  class2_={commoncss.gap20}

                  inputs={[
                    <>
                      <span className="input-label">Template</span>
                      <Select
                        placeholder="Template Name here(Auto-selected)"
                         options={[
                          { value: "option1", label: "Option 1" },
                          { value: "option2", label: "Option 2" },
                        ]}
                        onChange={(e) => handleChange("GAAP", e)}
                        className={`w-100 mt-0`}
                        classNamePrefix="select"
                        components={{
                          ...animatedComponents,
                          IndicatorSeparator: () => null,
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        styles={customSelectStyles}
                      />
                    </>,
                  ]}
                /> */}

                <InputGroup
                  class2_={commoncss.gap20}

                  inputs={[
                    <>
                      <InputGroup
                        label="Current Financial Year"
                        class_={commoncss.noActions}
                        inputs={[
                          <>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                <MobileDatePicker
                                  className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                  value={w_id === "noWp" ? (value?.currentDate ? dayjs(value?.currentDate) : null) : (workspaceData[0]?.standalone_cy ? dayjs(workspaceData[0]?.standalone_cy) : null)}
                                  onChange={(e) => getFinancialDate(e, "current")}
                                  // maxDate={moment().toDate()}
                                  format="DD-MMM-YYYY"
                                  slotProps={{
                                    textField: {
                                      InputProps: {
                                        disableUnderline: true,
                                        style: { height: "35px", boxSizing: "border-box" },
                                      },
                                      inputProps: {
                                        placeholder: "DD-MM-YYYY",
                                        style: { borderRadius: "6px" },
                                      },
                                      sx: {
                                        '& fieldset': {
                                          border: 'none',
                                        },
                                      },
                                    },
                                  }}
                                />

                              </DemoContainer>
                            </LocalizationProvider>
                            <span className="icon">
                              <CalenderIcon
                                className="vaMiddle"
                                width={20}
                                height={20}
                              />
                            </span>
                          </>,
                        ]}
                      />
                    </>,
                    <>
                      <InputGroup
                        label="Previous Financial Year"
                        class_={commoncss.noActions}
                        inputs={[
                          <>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                <MobileDatePicker
                                  className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                  value={w_id === "noWp" ? (value?.prevDate ? dayjs(value?.prevDate) : null) : (workspaceData[0]?.standalone_py ? dayjs(workspaceData[0]?.standalone_py) : null)}
                                  onChange={(e) => getFinancialDate(e, "previous")}
                                  // maxDate={moment().toDate()}
                                  format="DD-MMM-YYYY"
                                  slotProps={{
                                    textField: {
                                      InputProps: {
                                        disableUnderline: true,
                                        style: { height: "35px", boxSizing: "border-box" },
                                      },
                                      inputProps: {
                                        placeholder: "DD-MM-YYYY",
                                        style: { borderRadius: "6px" },
                                      },
                                      sx: {
                                        '& fieldset': {
                                          border: 'none',
                                        },
                                      },
                                    },
                                  }}
                                />

                              </DemoContainer>
                            </LocalizationProvider>
                            <span className="icon">
                              <CalenderIcon
                                className="vaMiddle"
                                width={20}
                                height={20}
                              />
                            </span>
                          </>,
                        ]}
                      />
                    </>,
                  ]}
                />
            
<InputGroup
  class2_={commoncss.gap20}
  inputs={[
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          gap: "20px",
        }}
      >
        {/* LEFT → Toggle */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px 0" }}>
          <label className="switch" style={{ width: "36px", height: "20px" }}>
            <input
              type="checkbox"
              checked={interimReporting}
              onChange={(e) => setInterimReporting(e.target.checked)}
              style={{ opacity: 0, width: 0, height: 0 }}
            />
            <span
              style={{
                position: "absolute",
                cursor: "pointer",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: interimReporting ? "#3AB67D" : "#ccc",
                borderRadius: "20px",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  height: "14px",
                  width: "14px",
                  left: interimReporting ? "19px" : "3px",
                  bottom: "3px",
                  backgroundColor: "white",
                  borderRadius: "50%",
                }}
              />
            </span>
          </label>

          <span className="input-label">Interim Reporting</span>
        </div>

      
        {interimReporting && (
          <div style={{ width: "48%" }}>
            <InputGroup
              label="Comparative Period"
              
              inputs={[
                <>
                  <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                    <input
                      type="text"
                      className={commoncss.datePickerContainer}
                      value={comparativePeriod ? dayjs(comparativePeriod).format("DD-MMM-YYYY") : ""}
                      readOnly
                      placeholder="DD-MMM-YYYY"
                      style={{ paddingRight: "36px", cursor: "pointer", height: "35px", boxSizing: "border-box", borderRadius: "6px" }}
                    />

                    {/* Hidden MUI picker — use inputRef, NOT slotProps field style */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["MobileDatePicker"]}>
                        <MobileDatePicker
                          inputRef={pickerRef}                       // ✅ key difference
                          value={comparativePeriod ? dayjs(comparativePeriod) : null}
                          onChange={(newValue) =>
                            setComparativePeriod(newValue ? newValue.toDate() : null)
                          }
                          format="DD-MMM-YYYY"
                          slotProps={{ field: { style: { display: "none" } } }}  // hide field
                        />
                      </DemoContainer>
                    </LocalizationProvider>

                    {/* Calendar icon triggers the picker */}
                    <CalenderIcon
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        zIndex: 10
                      }}
                      width={20}
                      height={20}
                      onClick={() => pickerRef.current?.click()}   // ✅ same as DateInput
                    />
                  </div>
                </>,
              ]}
            />
          </div>
        )}
      </div>
    </>,
  ]}
/>
                <InputGroup
                  class2_={commoncss.gap20}

                  inputs={[
                    <>
                      {w_id === "noWp" ? (
                        ""
                      ) : (<>
                        <span className="input-label">Select Presets / Chart of Accounts</span>
                        <Select
                          placeholder="Select Presets / Chart of Accounts"
                          options={presetAll}
                          onChange={(e) => setPreviousData(e)}
                          isMulti
                          closeMenuOnSelect={false}
                          className={`w-100 mt-0`}
                          classNamePrefix="select"
                          components={{
                            ...animatedComponents,
                            IndicatorSeparator: () => null,
                            DropdownIndicator: CustomDropdownIndicator,
                          }}
                          styles={customSelectStyles}
                        />
                      </>)}
                    </>,
                    <>
                      <InputGroup
                        label="Functional Currency"
                        inputs={[
                          <>
                            <input
                              type="text"
                              placeholder="Enter Functional Currency"
                              value={oneCompany?.functional}
                              style={{ height: "35px", boxSizing: "border-box", borderRadius: "6px" }}
                              disabled
                            />
                          </>
                        ]}
                      />
                    </>
                  ]}
                />
                <InputGroup
                  class2_={commoncss.gap20}

                  inputs={[
                    <>
                      <span className="input-label">Select Template</span>
                      <Select
                        placeholder="Select Template"
                        options={allTemplates}
                        onChange={(e) => setSelTemplate(e.value)}
                        className={`w-100 mt-0`}
                        classNamePrefix="select"
                        components={{
                          ...animatedComponents,
                          IndicatorSeparator: () => null,
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        styles={templateSelectStyles}
                        menuPlacement="bottom"
                        menuPosition="fixed"
                      />
                    </>,
                    <>
                      {/* <InputGroup
                        label="Nature of Company"
                        inputs={[
                          <>
                            <input
                              type="text"
                              placeholder="Enter nature of Company"
                              value={oneCompany?.nature_of_company}
                              disabled
                            />
                          </>,
                        ]}
                      /> */}
                    </>,
                  ]}
                />
              </div>
            </span>

          </motion.div>
          <div className={saCreationcss.footerContainer}>
            <div>
              <button
                onClick={() => history.push(`/financialstatement/${param.wid}`)}
                className={saCreationcss.cancelBtn} type="button" style={{ "padding": "7px" }}>Cancel</button>
            </div>
            <div className={saCreationcss.footerbtnContainer}>
             <CustomButton btnColor={buttoncss.secondary} onClick={() => history.goBack()}
              label="Previous" icon={<LeftIcon style={{ marginRight: "3px" }} />} disabled={true}  style={{ opacity: 0.5 }} />
              <button className={saCreationcss.saveBtn} type="button" onClick={() => handleSubmit()}
                disabled={valid ? false : true} style={{ "padding": "7px" }}>{previousdata ? "Save and Proceed" : "Next"} &nbsp;<RightIcon /></button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionnaireNew;
